import React from 'react';
import { formatDate } from '../../utils/suitableDate';
import { SAME_SLOT, INCOHERENT_HOURS } from '../../constants/error';
interface Range {
  selection: {
    startDate: Date;
    endDate: Date;
  };
}

export const onSelectDate = (ranges: Range, hasRangeDate: boolean, setState: React.Dispatch<React.SetStateAction<any>>, setSelection: React.Dispatch<React.SetStateAction<any>>) => {
  const { formattedStartDate, formattedEndDate } = formatDate(ranges.selection.startDate, ranges.selection.endDate);
  setState(prevState => {
    const { section } = prevState;
    return {
      section: {
        ...section,
        activationRange: {
          ...section?.activationRange,
          withDateRange: hasRangeDate,
          startDate: formattedStartDate,
          endDate: formattedEndDate,
        },
      },
    };
  });
  setSelection(ranges.selection);
};

export const handleChangeSwitch = (day: string, event: React.ChangeEvent<HTMLInputElement>, setState: React.Dispatch<React.SetStateAction<any>>) => {
  const isChecked = event?.target?.checked;
  setState((prevState) => {
    const { section } = prevState;
    const updatedDaysOfWeek = { ...section?.activationRange?.daysOfWeek };
    if (isChecked) {
      updatedDaysOfWeek[day] = { label: day, fullDay: true };
    } else {
      delete updatedDaysOfWeek[day];
    }

    return {
      section: {
        ...section,
        activationRange: {
          ...section?.activationRange,
          daysOfWeek: updatedDaysOfWeek,
        },
      },
    };
  });
};

export const handleChangeDate = (event: React.MouseEvent<HTMLButtonElement>, open: boolean, setOpen: React.Dispatch<React.SetStateAction<boolean>>, setAnchorElDate: React.Dispatch<React.SetStateAction<any>>) => {
  setOpen(!open);
  setAnchorElDate(event.currentTarget);
};

export const changeFullDay = (event: React.ChangeEvent<HTMLInputElement>, activationRange: any, day: string, setActivationRange: React.Dispatch<React.SetStateAction<any>>, setSlotErrorMessages: React.Dispatch<React.SetStateAction<string[]>>) => {
  const isChecked = event?.target?.checked;
  setActivationRange((prevState) => {
    const updatedDaysOfWeek = prevState?.daysOfWeek?.[day];
    updatedDaysOfWeek.fullDay = isChecked;

    updatedDaysOfWeek.slots = isChecked ? null : ['00:00-23:59'];

    return {
      ...activationRange,
      daysOfWeek: {
        ...prevState?.daysOfWeek,
        [day]: updatedDaysOfWeek,
      }
    };
  });
  setSlotErrorMessages([])
};

export const handleChangeHours = (
  day: string,
  value: string,
  type: string,
  activationRange: any,
  slot: string,
  index: number,
  setActivationRange: React.Dispatch<React.SetStateAction<any>>,
  setSlotErrorMessages: React.Dispatch<React.SetStateAction<string[]>>
) => {
  if (!activationRange || !activationRange?.daysOfWeek) {
    return;
  }

  const updatedDaysOfWeek = activationRange?.daysOfWeek[day];
  let [startTime, endTime] = slot?.split('-') || ['00:00', '23:59'];

  if (type === 'start') {
    startTime = value;
  } else if (type === 'end') {
    endTime = value;
  }
  const inValidHour = (type === 'start' && value >= endTime) || (type === 'end' && value <= startTime);

  if (updatedDaysOfWeek.slots) {
    updatedDaysOfWeek.slots[index] = `${startTime || '00:00'}-${endTime || '23:59'}`;
  } else {
    updatedDaysOfWeek.slots = [`${startTime || '00:00'}-${endTime || '23:59'}`]
  }
  const newSlotErrorMessages = getDuplicateSlots(updatedDaysOfWeek.slots);
  setSlotErrorMessages(newSlotErrorMessages);
  setActivationRange((prevState) => ({
    ...activationRange,
    daysOfWeek: {
      ...prevState.daysOfWeek,
      [day]: updatedDaysOfWeek,
    },
  }));
  setSlotErrorMessages((prevErrorMessages) => {
    const updatedErrorMessages = [...prevErrorMessages];
    updatedErrorMessages[index] = inValidHour ? INCOHERENT_HOURS : newSlotErrorMessages[index];
    return updatedErrorMessages;
  });
};


const timeToMinutes = (time) => {
  const [hours, minutes] = time.split(':');
  return parseInt(hours, 10) * 60 + parseInt(minutes, 10);
};
export const sortSlots = (slotsArray) => {
  return slotsArray.sort((slotA, slotB) => {
    const [startA, endA] = slotA.split('-');
    const [startB, endB] = slotB.split('-');

    const startMinutesA = timeToMinutes(startA);
    const startMinutesB = timeToMinutes(startB);


    if (startMinutesA !== startMinutesB) {
      return startMinutesA - startMinutesB;
    }

    const endMinutesA = timeToMinutes(endA);
    const endMinutesB = timeToMinutes(endB);
    return endMinutesA - endMinutesB;
  });
};

export const submitActivationRange = (
  activationRange: any,
  selectedDate: any,
  setState: React.Dispatch<React.SetStateAction<any | null>>,
  setSlotErrorMessages: React.Dispatch<React.SetStateAction<string[]>>,
  setOpenEditModal: () => void
) => {
  const newSlotErrorMessages = getDuplicateSlots(selectedDate?.slots);
  setSlotErrorMessages(newSlotErrorMessages)
  const hasErrors = newSlotErrorMessages.some((message) => message && message !== '');
  if (!hasErrors && (selectedDate?.fullDay || selectedDate?.slots)) {
    setState((prevState) => {
      return {
        section: {
          ...prevState.section,
          activationRange,
        },
      };
    });
    setOpenEditModal();
  }
};

const getDuplicateSlots = (slotsArray: string[]): string[] => {
  const errorMessages: string[] = new Array(slotsArray?.length).fill('');
  if (slotsArray) {
    for (let i = 0; i < slotsArray.length; i++) {
      for (let j = i + 1; j < slotsArray.length; j++) {
        if (slotsArray[i] === slotsArray[j]) {
          errorMessages[i] = errorMessages[j] = SAME_SLOT;
        }
      }
    }
    for (let i = 0; i < slotsArray.length; i++) {
      if (errorMessages[i] === '') {
        const [startTime, endTime] = slotsArray[i]?.split('-') || [];
        if (startTime && endTime && startTime > endTime) {
          errorMessages[i] = INCOHERENT_HOURS;
        }
      }
    }
  }
  return errorMessages;
};


export const handleActivateSection = (hasRangeDate: boolean, selection: Range['selection'], setState: React.Dispatch<React.SetStateAction<any>>, setHasRangeDate: React.Dispatch<React.SetStateAction<boolean>>) => {
  setState(prevState => {
    const { section } = prevState;
    return {
      section: {
        ...section,
        activationRange: !hasRangeDate ? {
          withDateRange: true,
          startDate: selection.startDate,
          endDate: selection.endDate,
          hiddenOutsideOfRange: false
        } : null,
      },
    };
  });
  setHasRangeDate(!hasRangeDate);
};
export const handleAddSlots = (activationRange: any, day: string, setActivationRange: React.Dispatch<React.SetStateAction<any>>) => {
  const updatedDaysOfWeek = activationRange?.daysOfWeek[day]
  const slots = updatedDaysOfWeek.slots || ['00:00-23:59']
  slots.push('00:00-23:59');
  updatedDaysOfWeek.slots = slots
  setActivationRange((prevState) => ({
    ...activationRange,
    daysOfWeek: {
      ...prevState.daysOfWeek,
      [day]: updatedDaysOfWeek,
    },
  }));
};
export const handleRemoveSlot = (activationRange: any, index: string, day: string, setActivationRange: React.Dispatch<React.SetStateAction<any>>, setSlotErrorMessages: React.Dispatch<React.SetStateAction<string[]>>) => {
  const updatedDaysOfWeek = activationRange?.daysOfWeek[day]
  if (updatedDaysOfWeek.slots.length > 1) {
    updatedDaysOfWeek.slots.splice(index, 1);
  }
  const newSlotErrorMessages = getDuplicateSlots(updatedDaysOfWeek?.slots)
  setActivationRange((prevState) => ({
    ...activationRange,
    daysOfWeek: {
      ...prevState.daysOfWeek,
      [day]: updatedDaysOfWeek,
    },
  }));
  setSlotErrorMessages(newSlotErrorMessages)
};